<app-system-messages />

@if (loader.loading()) {
  <div class="overlay">
    <div class="spinner">
      <mat-progress-spinner
        mode="indeterminate"
      ></mat-progress-spinner>
    </div>
  </div>
}

<div
  class="
    flex
    h-screen
    flex-col
    bg-background
  "
>

  <!--
    Global payroll alert.

    It is outside the router and above the
    sidebar/content layout.

    Therefore:
    - navigating does not remove it;
    - the sidebar is below it;
    - every authenticated page sees it;
    - landing/public pages do not.
  -->
  @if (
    auth.isLoggedIn &&
    showPayrollAlert()
  ) {

    @if (
      latestSalaryState();
      as salaryState
    ) {
      <app-payroll-period-alert
        [salaryState]="salaryState"
      />
    }

  }

  <!-- Application content -->
  <div
    class="
      flex
      min-h-0
      flex-1
    "
  >

    @if (auth.isLoggedIn) {
      <app-sidebar
        class="
          flex
          shrink-0
        "
      ></app-sidebar>
    }

    <!-- Main routed content -->
    <main
      class="
        flex
        min-w-0
        flex-1
        flex-col
        overflow-y-auto
      "
    >
      @if (auth.isLoggedIn && auth.organizationId) {
        <div class="flex justify-end px-4 py-2 border-b border-gray-200 bg-white">
          <app-notification-bell />
        </div>
      }
      <div class="h-full">
        <router-outlet />
      </div>
    </main>

  </div>

</div>
